import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthUrls } from './auth.model';

@Injectable({
  providedIn: 'root',
})
export class DSAuthService {
  public configuration;
  public authUrls: AuthUrls;
  public forgotPasswordFormValue: BehaviorSubject<object> = new BehaviorSubject(
    null,
  );
  public forgotPasswordFormValue$: Observable<object> =
    this.forgotPasswordFormValue.asObservable();
  public forgotUsernameFormValue: BehaviorSubject<object> = new BehaviorSubject(
    null,
  );
  public forgotUsernameFormValue$: Observable<object> =
    this.forgotUsernameFormValue.asObservable();
  public loginFormValue: BehaviorSubject<object> = new BehaviorSubject(null);
  public loginFormValue$: Observable<object> =
    this.loginFormValue.asObservable();
  public registrationFormValue: BehaviorSubject<object> = new BehaviorSubject(
    null,
  );
  public registrationFormValue$: Observable<object> =
    this.registrationFormValue.asObservable();

  submitLogin(value) {
    this.loginFormValue.next(value);
  }

  submitRegistration(value) {
    this.registrationFormValue.next(value);
  }

  submitForgotPassword(value) {
    this.forgotPasswordFormValue.next(value);
  }

  submistForgotUsername(value) {
    this.forgotUsernameFormValue.next(value);
  }
}
